<template>
    <div>
        <header>Filter Projects</header>
        <Group
            v-for="group in facs"
            v-bind:key="group.title"
            v-bind:title="group.title"
            v-bind:dropdowns="group.dropdowns"
            v-on:input="$emit('fac', $event)"
        />
        <Group
            v-for="group in groups"
            v-bind:key="group.title"
            v-bind:title="group.title"
            v-bind:dropdowns="group.dropdowns"
            v-on:input="$emit('input', $event)"
        />
        <costFilter
            v-on:input="$emit('input', $event)"
        />
        <streetFilter
            v-on:input="$emit('input', $event)"
        />
    </div>
</template>

<script>
    import Group from "./Group";
    import costFilter from "./costFilter";
    import streetFilter from "./streetFilter";

    export default {
        name: "SideBar",
        components: {Group, costFilter, streetFilter},
        props:['start_years', 'end_years', 'project_types'],
        data: function () {
            return {}
        },
        computed: {
            groups: function (){
                return [
                    {
                        title: "Project System",
                        dropdowns: [
                            {
                                name: "project_system",
                                values: [
                                    {"name": "Water", "statevalue": 'Water'},
                                    {"name": "Sewer", "statevalue": 'Sewer'},
                                    {"name": "Storm", "statevalue": 'Storm'},
                                    {"name": "Road", "statevalue": 'Road'},
                                    {"name": "Gas", "statevalue": 'Gas'},
                                    {"name": "Electric", "statevalue": 'Electric'},
                                ]
                            },
                        ],
                    },
                    {
                        title: "Project Type",
                        dropdowns: [
                            {
                                name: "project_type",
                                values: this.project_types,
                            },
                        ],
                    },
                    {
                        title: "Construction Start Year",
                        dropdowns: [
                            {
                                name: "start_year",
                                values: this.start_years,
                            },
                        ],
                    },
                    {
                        title: "Construction End Year",
                        dropdowns: [
                            {
                                name: "end_year",
                                values: this.end_years,
                            },
                        ],
                    },
                ]
            },
          facs: function (){
                return [
                  {
                        title: "Federal Aid Committee",
                        dropdowns: [
                            {
                              name: "large_area_id",
                              values: [
                                {"name": "Detroit", "statevalue": '5'},
                                {"name": "Livingston County", "statevalue": '93'},
                                {"name": "Macomb County", "statevalue": '99'},
                                {"name": "Monroe County", "statevalue": '115'},
                                {"name": "Oakland County", "statevalue": '125'},
                                {"name": "St. Clair County", "statevalue": '147'},
                                {"name": "Washtenaw County", "statevalue": '161'},
                                {"name": "Wayne County, Excluding Detroit", "statevalue": '3'},
                              ]
                            },
                        ],
                    },
                ]
            },
        },
    }
</script>

<style scoped>
    div {
        background-color: #0f2d53;
    }

    header {
        color: white;
        font-size: medium;
        padding: 5px;
    }
</style>
